import React, { useState } from 'react';

const socialMediaTabsData = [
  {
    id: 'complete-strategy',
    title: 'Complete Social Media Strategy',
    contentTitle: 'Complete Social Media Strategy',
    desc: 'Being one of the trusted social media marketing agencies in Pakistan, we craft marketing plans for different social media portals like LinkedIn, Facebook, Instagram, TikTok, and Pinterest that increase your brand awareness and engage with your audience. We are here to help you create a strong digital presence on social media channels. You can hire us for result driven social media management services. We provide:',
    bullets: [
      'Monthly content calendar',
      'Professionally designed posts',
      'Platform-specific strategies',
      'Caption writing and hashtag planning',
      'Scheduled posting across platforms',
      'Audience and competitor analysis',
      'Monthly performance reports',
      'Growth and engagement tracking',
      'Post improvements and ad management (if included)',
      'Ongoing support and strategy adjustments'
    ],
    bottomText: 'We perform complete industry research and conduct audits to build a productive plan for your unique needs. Invest your money in suitable social media portals and communicate with your audience to multiply your revenue.'
  },
  {
    id: 'social-media-management',
    title: 'Social Media Management',
    contentTitle: 'Social Media Management',
    desc: 'We apply creative ideas and use productive methods to improve the performance of your online channels. Our experts craft the organic content for your social media platforms. We also analyze and optimize the content on a regular basis. We make sure to provide:',
    bullets: [
      'Customized social media strategy',
      'Increased engagement and followers',
      'Optimized social media profiles',
      'Regular performance reports',
      'Targeted ad campaigns',
      'Creative content creation',
      'Trend and hashtag research',
      'Community management',
      'Audience growth',
      'Reputation monitoring',

    ],
    bottomText: 'Experts Communication is here to strategize your monthly calendar and handle your posting schedules for various platforms that help establish credibility among competitors.'
  },
  {
    id: 'content-creation',
    title: 'Content Creation',
    contentTitle: 'Content Creation',
    desc: 'In a fast-paced digital world, thumb-stopping visual and motion design makes all the difference. Our creative studio produces compelling graphics, high-converting video reels, animated stories, and engaging carousels tailored to your brand identity. We turn complex ideas into engaging visual stories. Our content creation includes:',
    bullets: [
      'High-resolution custom graphic designs',
      'Short-form vertical video (Reels, TikToks, Shorts)',
      'Engaging carousel posts and infographics',
      'Product photography & lifestyle asset edits',
      'Interactive story templates and motion graphics',
      'Persuasive storytelling copywriting and call-to-actions',
      'Brand aesthetic and visual guideline alignment'
    ],
    bottomText: 'Transform your social media pages into visually stunning portfolios that spark curiosity, captivate potential buyers, and dramatically increase post shareability.'
  },
  {
    id: 'content-marketing',
    title: 'Content Marketing',
    contentTitle: 'Content Marketing',
    desc: 'Content marketing goes beyond standard posts—it establishes thought leadership, builds authority, and nurtures prospects through targeted marketing funnels. We create value-driven content pieces that educate your target demographic and position your brand as the leading authority in your industry. Our strategic content marketing includes:',
    bullets: [
      'Strategic content pillar planning',
      'Educational carousels and industry guides',
      'B2B thought leadership articles on LinkedIn',
      'Case studies, client transformations, and success stories',
      'User-generated content (UGC) campaign curation',
      'Lead-magnet promotion and newsletter funnels',
      'Content repurposing across multiple digital touchpoints'
    ],
    bottomText: 'Attract qualified prospective clients by giving them actionable value before they even make their first purchase, turning cold audiences into eager brand advocates.'
  },
  {
    id: 'social-media-advertising',
    title: 'Social Media Advertising',
    contentTitle: 'Social Media Advertising',
    desc: 'Scale your customer acquisition with precision-targeted paid advertising. We design, launch, and optimize high-ROI ad campaigns on Meta (Facebook & Instagram), TikTok Ads, and LinkedIn Campaign Manager to generate consistent leads, app installs, and online sales. Our advertising framework features:',
    bullets: [
      'Advanced demographic, interest, and behavioral targeting',
      'Custom lookalike audience creation and pixel retargeting',
      'High-converting ad copy and multi-format creative testing',
      'A/B testing of headlines, visuals, and landing pages',
      'Conversion Rate Optimization (CRO) and funnel tracking',
      'Daily budget monitoring to lower Cost Per Acquisition (CPA)',
      'Clear transparent ROAS (Return On Ad Spend) dashboards'
    ],
    bottomText: 'Maximize every dollar of your advertising budget with data-backed media buying strategies engineered to produce predictable revenue and business expansion.'
  },
  {
    id: 'social-media-audit',
    title: 'Social Media Audit',
    contentTitle: 'Social Media Audit',
    desc: 'Discover what’s working, what’s holding your brand back, and where your biggest growth opportunities lie. Our thorough social media audit evaluates your profile setup, content performance, competitor benchmarks, and engagement ratios to formulate an actionable roadmap for immediate improvement. Our audit comprises:',
    bullets: [
      'Profile bio, link, and branding optimization check',
      'Comprehensive engagement rate and reach analysis',
      'In-depth competitor benchmark comparisons',
      'Content gap identification and posting frequency review',
      'Audience demographic and follower quality evaluation',
      'Ad account setup and pixel tracking verification',
      'Actionable roadmap with prioritized quick-win recommendations'
    ],
    bottomText: 'Get clear, actionable recommendations to fix blind spots, optimize existing profiles, and fast-track your social media growth.'
  }
];

function SocialMediaTabsSection() {
  const [activeTabId, setActiveTabId] = useState('complete-strategy');

  const activeTab =
    socialMediaTabsData.find((item) => item.id === activeTabId) || socialMediaTabsData[0];

  return (
    <section className="seo-tabs-section">
      <div className="container">
        {/* Section Header: 2-Column Row */}
        <div className="seo-tabs-header-row">
          <div className="seo-tabs-header-left">
            <h2 className="seo-tabs-main-title">
              What You’ll Expect From Our <span className="seo-red-title">Social Media Marketing Services</span>
            </h2>
          </div>
          <div className="seo-tabs-header-right">
            <p className="seo-tabs-header-desc">
              Marketing is very different and technical nowadays. Now it is not limited to banners and billboards. Marketing needs effort and a proper plan for the best outcomes. Billboards hardly make an impact on the audience now. But the social media marketing platforms present great opportunities for targeted and result oriented outcomes.
            </p>
          </div>
        </div>

        {/* Tabs Main Grid: Left Vertical Sidebar Tabs, Right White Content Box */}
        <div className="seo-tabs-main-grid">
          {/* Left Side: Dark Vertical Sidebar Tabs */}
          <div className="seo-tabs-sidebar">
            <ul className="seo-tabs-list">
              {socialMediaTabsData.map((item) => {
                const isActive = item.id === activeTabId;
                return (
                  <li key={item.id} className="seo-tab-item">
                    <button
                      className={`seo-tab-button ${isActive ? 'active' : ''}`}
                      onClick={() => setActiveTabId(item.id)}
                    >
                      {item.title}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Right Side: White Tab Content Card */}
          <div className="seo-tab-content-card">
            <h3 className="seo-tab-content-heading">
              {activeTab.contentTitle}
            </h3>

            <p className="seo-tab-content-desc">
              {activeTab.desc}
            </p>

            {activeTab.bullets && activeTab.bullets.length > 0 && (
              <ul className="seo-tab-bullets-list">
                {activeTab.bullets.map((bullet, idx) => (
                  <li key={idx} className="seo-tab-bullet-item">
                    {bullet}
                  </li>
                ))}
              </ul>
            )}

            {activeTab.bottomText && (
              <p className="seo-tab-content-bottom">
                {activeTab.bottomText}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialMediaTabsSection;
